module.exports = __webpack_public_path__ + "1741bfa4c75cc81a07eec97cb286d942.pdf";